<template>
  <nv-tab-page>
    <template slot="toolbar">
      <nv-btn v-if="canEdit()" type="add" data-cy="add-parameter" @click="newForm.show = true" />
      <new-parameter-form
        v-model="newForm.show"
        :added-parameter-ids="addedParameterIds"
        @saved="addParameter"
      />

      <v-spacer />
      <nv-table-search v-model="search" class="ml-4" />
    </template>

    <template slot="filters">
      <nv-table-filters :value="tableFilters" @clear="$refs['filter-sheet'].clearFilters()">
        <filter-sheet ref="filter-sheet" @changed="setTableFilters" />
      </nv-table-filters>
    </template>
    <v-data-table
      :headers="headers"
      :items="items"
      :loading="loading"
      :options.sync="table"
      :server-items-length="totalItems"
      :footer-props="footerProps"
      :items-per-page.sync="table.itemsPerPage"
      must-sort
    >
      <template #item="{ item }">
        <tr>
          <td class="text-center">
            <v-btn icon small color="error" @click="removeParameter(item)">
              <v-icon small>mdi-close</v-icon>
            </v-btn>
          </td>
          <td>{{ item.master_parameter.name }}</td>
          <td>{{ item.value || item.master_parameter.default_value }}</td>
          <td>{{ item.encoding || item.master_parameter.encoding }}</td>
          <td>{{ item.master_parameter.description }}</td>
          <td>{{ item.master_parameter.parameter_type | enumLabel(enumParameterTypes) }}</td>
          <td>
            <product-chip-group v-model="item.master_parameter.products" />
          </td>
          <td>{{ item.status | enumLabel(enumStatuses) }}</td>
          <td class="text-right">
            <v-btn v-if="canEdit()" icon class="param-edit-icon" @click="openEdit(item)">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>

    <edit-form v-model="editDialog.show" :editing="editDialog.edit" @saved="updateParameter" />
  </nv-tab-page>
</template>

<script>
import HTTP from '@/api/dog';
import { TableMixin, enumFetch } from '@nielsen-media/ui-toolkit-vue-api';
import NewParameterForm from '@/components/parameters/BulkNewForm.vue';
import EditForm from '@/components/parameters/BulkEditForm.vue';
import FilterSheet from '@/components/parameters/FilterSheet.vue';
import ProductChipGroup from '@/components/ProductChipGroup.vue';

const headers = [
  { text: '', align: 'center', sortable: false, value: 'actions', width: '50px' },
  { text: 'Name', align: 'left', sortable: false, value: 'name' },
  { text: 'Value', align: 'left', sortable: false, value: 'value' },
  { text: 'Encoding', align: 'left', sortable: false, value: 'encoding' },
  { text: 'Description', align: 'left', sortable: false, value: 'description' },
  { text: 'Type', align: 'left', sortable: false, value: 'parameter_type' },
  { text: 'Products', align: 'left', sortable: false, value: 'products' },
  { text: 'Status', align: 'left', sortable: false, value: 'status' },
  { align: 'right', sortable: false },
];

export default {
  components: {
    NewParameterForm,
    EditForm,
    FilterSheet,
    ProductChipGroup,
  },
  mixins: [TableMixin],
  props: {
    isEditable: { type: Boolean, default: true },
  },
  data: () => ({
    headers,
    filters: {
      status: 'active',
    },
    newForm: { show: false },
    editDialog: { show: false, edit: null },
    enumStatuses: [],
    enumParameterTypes: [],
    tableParam: 'params.dt',
  }),
  computed: {
    addedParameterIds() {
      return this.items.map(item => item.master_parameter_id);
    },
  },
  created() {
    this.enumFetch(HTTP, {
      enumStatuses: '/parameters/enum/statuses',
      enumParameterTypes: '/parameters/enum/types',
    });
  },
  methods: {
    tableFetch() {
      // Keep list empty - no fetch
    },
    addParameter(param) {
      if (!param || !param.master_parameter || !param.master_parameter_id) {
        return;
      }
      this.items.push(param);
      this.totalItems = this.items.length;
      this.$emit('parameter-added', param);
    },
    updateParameter(param) {
      const index = this.items.findIndex(i => i.master_parameter_id === param.master_parameter_id);
      if (index !== -1) {
        const updatedParam = { ...param };
        this.$set(this.items, index, updatedParam);
        this.items = [...this.items];
        this.$emit('parameter-updated', updatedParam);
      }
    },
    openEdit(item) {
      this.editDialog.edit = item;
      this.editDialog.show = true;
    },
    removeParameter(item) {
      const index = this.items.findIndex(i => i.master_parameter_id === item.master_parameter_id);
      if (index !== -1) {
        this.items.splice(index, 1);
        this.totalItems = this.items.length;
        this.$emit('parameter-removed', item);
      }
    },
    canEdit() {
      return this.isEditable;
    },
    getData() {
      return { parameters: this.items };
    },
    enumFetch,
  },
};
</script>
